export default __webpack_public_path__ + "files/1c1f5e7a394a83c2f3c706bf05923d9a.mp3";